import { connect } from 'react-redux';

import { getSoilsListForZoneId, zoneSoilsAreVisible } from 'current/selectors';

import { toggleZoneSoils } from 'current/uiwidgets';
import ZoneSoilCompositionContainer from './ZoneSoilCompositionContainer';

export default connect(
  (state, ownProps) => {
    const { zoneId } = ownProps;
  
    return {
      soils: getSoilsListForZoneId(state, zoneId),
      soilsAreVisible: zoneSoilsAreVisible(state, zoneId),
      zoneId
    };
  },
  (dispatch, ownProps) => {
    const { zoneId } = ownProps;
  
    return {
      onClick: (e) => { e.stopPropagation(); dispatch(toggleZoneSoils(zoneId)); }
    };
  }
)(ZoneSoilCompositionContainer);